import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, LeafIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-wellness-sage/30 to-wellness-cream pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-51">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-52">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-wellness-sage/40 blur-3xl opacity-60" data-id="element-53" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-wellness-accent/10 blur-3xl opacity-60" data-id="element-54" />
      </div>

      <div className="max-w-7xl mx-auto w-full" data-id="element-55">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-56">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center text-center lg:items-start lg:text-left order-2 lg:order-1" data-id="element-57">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-wellness-accent/10 text-wellness-accent font-medium text-sm mb-6 border border-wellness-accent/20" data-id="element-58">
              <LeafIcon className="w-4 h-4" data-id="element-59" />
              <span data-id="element-60">Plan Antiinflamatorio</span>
            </motion.div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6" data-id="element-61">
              14 Días de <br className="hidden lg:block" data-id="element-62" />
              <span className="text-wellness-medium italic font-serif" data-id="element-63">
                Desinflamación
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-wellness-text/80 max-w-xl mb-10 leading-relaxed" data-id="element-64">
              Tu guía completa para reducir la inflamación con comida real. Un
              plan simple, delicioso y efectivo para recuperar tu bienestar.
            </p>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => window.open('https://vitalizateahora.com/cart/51849946562791:1', '_blank')} className="px-8 py-4 bg-wellness-primary text-white rounded-2xl font-medium text-lg shadow-organic hover:bg-wellness-primary/90 transition-colors flex items-center gap-3 group" data-id="element-65">
              Comenzar el Plan
              <ChevronDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-66" />
            </motion.button>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-67">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-68">
              <div className="absolute inset-0 bg-wellness-sage rounded-[2.5rem] transform rotate-3 scale-105 -z-10 opacity-50" data-id="element-69"></div>
              <img src="https://cdn.magicpatterns.com/uploads/r2g713Xb9UTCAgRHavia7o/heylloyd-image-1773069765156.png" alt="14 Días Sin Desinflamación" className="w-full h-auto rounded-[2rem] shadow-organic object-cover" data-id="element-70" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center text-wellness-medium/60 animate-bounce" data-id="element-71">
        <span className="text-xs font-medium uppercase tracking-widest mb-2" data-id="element-72">
          Descubre
        </span>
        <ChevronDownIcon className="w-5 h-5" data-id="element-73" />
      </motion.div>
    </section>;
}